<template>
  <el-row :gutter="20">
    <el-col :span="16">
      <el-select v-model="city">
        <el-option
          v-for="item in cityData"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-col>
    <el-col :span="8">
      <el-select v-model="zipCode">
        <el-option
          v-for="item in zipCodeData"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-col>
  </el-row>
</template>

<script>
  import {cityData} from '../../common-data/config.js';

  export default {
  name: "CityAndZipCode",
  model: {
    prop: 'cityAndZipCode',
    event: 'change'
  },
  props: ['cityAndZipCode', 'province'],
  data() {
    console.log(cityData)
    // const city = cityData[this.province] || [{zipCodes: []}];
    return {
      // cityData: city,
      // zipCodeData: city[0].zipCodes,
      cityData: [],
      zipCodeData: [],
      city: '',
      zipCode: '',
    };
  },

  watch: {
    province(newValue) {
      const city = cityData[newValue] || [];
      this.cityData = city;
      this.zipCodeData = city ? city[0].zipCodes : [];
      this.city = city[0].value;
      this.zipCode = this.zipCodeData[0].value;
    },
    cityAndZipCode(newValue) {
      const [city = '', zipCode = ''] = (newValue ||'-').split('-');
      this.city = city;
      this.zipCode = zipCode;
    },
    city(newValue) {
      console.log(cityData)
      console.log(cityData[this.province].find(item => item.value === newValue))
      this.zipCodeData = cityData[this.province].find(item => item.value === newValue).zipCodes;
      this.zipCode = this.zipCodeData[0].value;
      this.$emit('change', `${this.city}-${this.zipCode}`);
    },
    zipCode() {
      this.$emit('change', `${this.city}-${this.zipCode}`);
    }
  },

  methods: {
    
  }
}
</script>

<style lang="scss" scoped>

</style>